import script from "./Static.vue?vue&type=script&setup=true&lang=ts"
export * from "./Static.vue?vue&type=script&setup=true&lang=ts"

import "./Static.vue?vue&type=style&index=0&id=d269fd8e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d269fd8e"]])

export default __exports__